import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: resolve => require(["@/view/HomePage"], resolve),
      meta: {
        title:
          "技森科技_深圳市技森科技有限公司|小程序开发|APP定制|软件开发|CRM系统开发"
      }
    },
    {
      path: "/about",
      name: "about",
      component: resolve => require(["@/view/About"], resolve),
      meta: {
        title: "关于技森_深圳市技森科技有限公司"
      }
    },
    {
      path: "/services/appDev",
      name: "appDev",
      component: resolve => require(["@/view/appDev"], resolve),
      meta: {
        title: "APP开发_深圳市技森科技有限公司"
      }
    },
    {
      path: "/services/appletDev",
      name: "appletDev",
      component: resolve => require(["@/view/appletDev"], resolve),
      meta: {
        title: "小程序定制_深圳市技森科技有限公司"
      }
    },
    {
      path: "/services/webDev",
      name: "webDev",
      component: resolve => require(["@/view/webDev"], resolve),
      meta: {
        title: "网页开发_深圳市技森科技有限公司"
      }
    },
    {
      path: "/services/softwareDev",
      name: "softwareDev",
      component: resolve => require(["@/view/softwareDev"], resolve),
      meta: {
        title: "软件开发_深圳市技森科技有限公司"
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: resolve => require(["@/view/Contact"], resolve),
      meta: {
        title: "联系我们_深圳市技森科技有限公司"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js